import {MathsNaiveStatic} from "./maths-naive-static";
import {MathsNaiveDynamic} from "./maths-naive-dynamic";
import {MathsNaiveStaticV5} from "./maths-naive-static-v5";

export class MathsNaive {

    public project: number;
    public dateStart: Date = new Date();
    public dateEnd: Date = new Date();
    public doStatic: boolean = false;
    public doDynamic: boolean = false;
    public paramStatic: MathsNaiveStatic = new MathsNaiveStatic();
    public paramDynamic: MathsNaiveDynamic = new MathsNaiveDynamic();
    public paramStaticV5: MathsNaiveStaticV5 = new MathsNaiveStaticV5();

    constructor(id: number) {
        this.project = id;
    }

    public setMathsNaive(data: any) {
        this.dateStart = data.dateStart;
        this.dateEnd = data.dateEnd;
        this.doStatic = data.doStatic;
        this.doDynamic = data.doDynamic;

        this.paramStatic.windowSize = data.paramStatic.windowSize;
        this.paramStatic.noteMAX = data.paramStatic.noteMAX;
        this.paramStatic.coefLT = data.paramStatic.coefLT;
        this.paramStatic.coefCT = data.paramStatic.coefCT;
        this.paramStatic.coefVF = data.paramStatic.coefVF;
        this.paramStatic.refLT = data.paramStatic.refLT;
        this.paramStatic.refCT = data.paramStatic.refCT;

        this.paramDynamic.split_tg = data.paramDynamic.split_tg;
        this.paramDynamic.split_tr = data.paramDynamic.split_tr;
        this.paramDynamic.sampleInt = data.paramDynamic.sampleInt;
        this.paramDynamic.split_ts_val = data.paramDynamic.split_ts_val;
        this.paramDynamic.split_tr_val = data.paramDynamic.split_tr_val;
        this.paramDynamic.split_tr_sign = data.paramDynamic.split_tr_sign;
        this.paramDynamic.split_tr_pretrig = data.paramDynamic.split_tr_pretrig;
        this.paramDynamic.split_tr_postrig = data.paramDynamic.split_tr_postrig;

        this.paramStaticV5.sensor_X = data.paramStaticV5.sensor_X;
        this.paramStaticV5.sensor_Y = data.paramStaticV5.sensor_Y;

    }

}
